import React, { PureComponent } from "react";

import { Table, Button } from "reactstrap";

import axios from "axios";


//import '../Assets/css/mdb.min.css';
import "../Assets/css/style.css";
import "../Assets/css/responsive.css";
//import "../Assets/js/mdb.min.js";
//import "../Assets/js/jquery-2.2.4.min.js";
//import "../Assets/js/jquery.bxslider.js";




import Header from './Header';
import Slider from './Slider';
import Footer from './Footer';
import Middle from './Middle';
import Benifit from './Benifit';
//import TeacherList from '../components/TeacherList';
import SchoolEasy from './SchoolEasy';
import Client from './Client';
import MobieApp from './MobieApp';
import DemoRequestForm from './DemoRequestForm';

export class App extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      students: [],
      newStudentData: {
        //first_name: "",
        //    last_name: "",
        //    email: "",
        //    phone: "",
        //school_name: "",
              // board:"",
              // state:"",
              // district:"",
              // school_website:"",
              // total_student:"",
              // contant_person_name:"",
              // contant_person_designation:"",
              // contact_number:"",
              // contact_email:"",
              // preferred_date_time:"",
              // referred_itgk_code:"",
              // referred_itgk_name:"",
      },
      //      agreement: false,
      //isAgreementChecked: false,
      hasNameError: true,
      // hasDescriptionError: true,
      // hasMovieError: true,
      // hasJobError: true,
      //hasAgreementError: true,
      validate: false,
      
      isLoading: false,
      status: "",
      //newStudentModal: false,
      
    };
    //this.validateForm = this.validateForm.bind(this);
    this.onChangeAddStudentHandler = this.onChangeAddStudentHandler.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
  }

onChangeAddStudentHandler = (e) => {
  console.log(e);
    let { newStudentData } = this.state;
    newStudentData[e.target.name] = e.target.value;
    this.setState({ newStudentData });
    console.log(e);
};

addStudent = () => {
    axios
      .post(
        "http://localhost:8080/api/demorequest",
        this.state.newStudentData
      )
      .then((response) => {
        const { students } = this.state;
        const newStudents = [...students];
        newStudents.push(response.data);
        this.setState(
          {
            students: newStudents,
            newStudentModal: false,
            newStudentData: {
              school_name: "fds",
              last_name: "sdf",
              email: "sd@g",
              phone: "fg",
            },
          },
          //() => this.getStudents()
        );
      });
  };
  

  componentDidMount() {
    this.getDemoRequestData();
  } 
  getDemoRequestData() {
    axios.get("http://localhost:8080/api/demorequest/school").then((response) => {
      console.log(response.data);
        if (response.status === 200) {
        this.setState({
            students: response.data ? response.data : [],
        });
        }
        console.log(this.state);
        if (
        response.data.status === "failed" &&
        response.data.success === false
        ) {
        this.setState({
            noDataFound: response.data.message,
        });
        }
    });
    } 
  render() {
    const { newStudentData, noDataFound,students} = this.state;
    /*let studentsDetails = [];
      if (students.length) {
        studentsDetails = students.map((student) => {
          return (
            <tr key={student.id}>
              
              <td>{student.school_logo}</td>
              
            </tr>
            
          );
        });
      }*/
      
    return (
      <div>
      	<Header/>
        <Slider/>
        <Middle
        students={students}/>
        <Benifit/>
        
        <SchoolEasy/>
        <Client
        students={students}/>
        <MobieApp/>
        <DemoRequestForm 
        onChangeAddStudentHandler={this.onChangeAddStudentHandler}
        addStudent={this.addStudent}
        validate={this.validate}
        newStudentData={newStudentData}
        />
        <Footer/>
        
      </div>
    );
  }
}

export default App